import React from 'react'
import numeral from 'numeral';

export default ({ caption='', value=0, total=false}) => (
  <div className={`Summary-Line ${!total ? '' : 'total'}`}>
    <div className="label">{caption}</div>
    <div className="value">{numeral(value).format('0,0.00')}</div>
  </div>
)
